import BaseComponent from "@js/components/base_component.jsx";
import EuiIndexSearchBar from "@js/components/eui/index_search_bar.jsx";
import EuiSharedTrackingDomainsIndexTable from "@js/components/eui/shared_tracking_domains/index_table.jsx";

class EuiSharedTrackingDomainsIndex extends BaseComponent {

  render() {
    const table = this.props.shared_tracking_domains;
    const filtered = !!( this.props.q || this.props.dns_state );

    return (
      <div>
        <EuiIndexSearchBar
          q={ this.props.q }
          placeholder={ I18n.t("phrases.search_shared_tracking_domains") }
          indexPath={ Routes.eui_shared_tracking_domains_path }
          filters={ [
            {
              name: "dns_state",
              value: this.props.dns_state,
              blankLabel: I18n.t("blank_options.dns_state"),
              options: [
                { value: "not_verified", label: I18n.t("dns_state_filters.not_verified") },
                { value: "verified_good", label: I18n.t("dns_state_filters.verified_good") },
                { value: "verified_regressed", label: I18n.t("dns_state_filters.verified_regressed") },
              ],
            },
          ] }
        />

        <Panel heading="shared_tracking_domains">
          <EuiSharedTrackingDomainsIndexTable
            table={ table && table.data }
            library={ this.props.library }
            filtered={ filtered }
          />
          {table && table.total > 0 && <Paginator entity={table} />}
        </Panel>
      </div>
    );
  }

}

export default EuiSharedTrackingDomainsIndex;
